module.exports = __webpack_public_path__ + "static/media/Link_pad.4fe31347.png";